import React from 'react';
import './footer.css';

function Footer() {

  return (
    <div id="footer"className="footer-container">
      <p className="footer-description">
        © Alson Zhang 2020
      </p>
    </div>
  );
}

export default Footer;
